<template>
    <!-- z-[-1] -->
    <div>
        <div
            ref="box"
            :style="{
                'max-height': hidden ? minHeight + 'px' : height + 'px',
            }"
            class="transition-all overflow-hidden duration-500 ease-in-out relative"
        >
            <div ref="p">
                <slot
                    :hidden="hidden"
                    :close="
                        () => {
                            hidden = !hidden
                        }
                    "
                />
            </div>
        </div>

        <button v-if="showButton" class="flex items-center mt-2" @click="hidden = !hidden">
            <p :class='[buttonCSS]' class="w-20 text-left">Show {{ hidden ? 'more' : 'less' }}</p>
            <IconArrowDown :class="{ 'rotate-180': !hidden }" class="ml-2 h-4.5 w-4.5 stroke-black transition-all ease-in-out" />
        </button>
    </div>
</template>

<script>
export default {
    props: {
        minHeight: {
            type: Number,
            default: 66,
        },
        forceShowMore: { type: Boolean, default: false },
        buttonCSS: { type: String, default: "text-14 font-semibold text-grey-900 " }
    },

    mounted() {
        this.$nextTick(() => {
            const observer = new MutationObserver(this.setShowButton)
            observer.observe(this.$refs.p, {
                childList: true,
                subtree: true,
            })
            this.observer = observer
            this.setShowButton()
        })
    },

    beforeUnmount() {
        this.observer.disconnect()
    },

    created() {
        window.addEventListener('resize', this.setShowButton)
    },

    destroyed() {
        window.removeEventListener('resize', this.setShowButton)
    },

    data() {
        return {
            hidden: true,
            showButton: true,
            height: 66,
            observer: null,
        }
    },

    methods: {
        setShowButton() {
            // console.log(this.$refs.p.clientHeight)
            this.height = this.$refs.p.clientHeight

            if (this.height == 0) {
                setTimeout(() => {
                    this.setShowButton()
                }, 200)
                return
            }

            this.showButton = this.forceShowMore ? true : this.height > 66
        },
    },
}
</script>
